import { render, staticRenderFns } from "./OsAppUsersByCampaignOverview.vue?vue&type=template&id=83edc0a0&scoped=true"
import script from "./OsAppUsersByCampaignOverview.vue?vue&type=script&lang=ts"
export * from "./OsAppUsersByCampaignOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83edc0a0",
  null
  
)

export default component.exports